import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper, Typography } from '@mui/material';

import childSelector from '../../../../children/childSelector';
import { loadChildren } from '../../../../children/childrenReducer';
import type { AppDispatch } from '../../../../store';
import ChildEntry from './ChildEntry';

type Props = {
  clientId: string;
};

function ChildrenList({ clientId }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const children = useSelector(childSelector.getChildren);

  useEffect(() => {
    dispatch(loadChildren());
  }, []);

  const filteredChildren = children.filter((child) => child.payload.clientId === clientId);

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        margin: '24px 0',
        padding: '20px 24px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Grid container rowSpacing={2} columnSpacing={4}>
        {filteredChildren.map((child) => (
          <ChildEntry key={child.id} child={child} />
        ))}
      </Grid>
    </Paper>
  );
}

export default ChildrenList;
